// Variant Radio Button Visual Handler
// Handles the visual selection states for product variant radio buttons.
//
// v2.5 fix (2026-05-13): updateVariantId() previously composed selectedOptions
// from CHECKED RADIOS ONLY (ignoring the size <select>) and then wrote a baked
// data-variant-id from the matched radio directly to #product-variant-id. That
// caused the size selection to revert to the first variant whenever a finish
// card was clicked after the size dropdown had been changed. Variant-ID
// resolution is now delegated to window.variantSelector.updateVariant (canonical
// resolver) and add-to-cart.liquid's inline computeVariantFromSelectedOptions
// (which correctly reads BOTH the size select and the checked radios). The
// findMatchingVariantRadio helper is removed (no longer called). The duplicate
// setTimeout(init, 500) is removed — it was double-binding change listeners on
// every radio, doubling work per click. Visual sync (.selected class on labels)
// stays untouched.

(function() {
  'use strict';

  function initVariantRadioHandler() {
    const radioButtons = document.querySelectorAll('.product-header_radio input[type="radio"]');
    if (radioButtons.length === 0) return;

    radioButtons.forEach(radio => {
      radio.addEventListener('change', handleRadioChange);
      radio.addEventListener('click', handleRadioClick);

      const label = radio.closest('label');
      if (label) {
        label.addEventListener('click', () => {
          setTimeout(() => {
            if (!radio.checked) {
              radio.checked = true;
              handleRadioChange({ target: radio });
            }
          }, 10);
        });
      }
    });

    updateAllVisualStates();
  }

  function handleRadioClick(e) {
    setTimeout(() => { handleRadioChange(e); }, 10);
  }

  function handleRadioChange(e) {
    const radio = e.target;
    updateVisualStatesForOption(radio.name);

    // Delegate variant-ID resolution to the canonical resolver.
    // add-to-cart.liquid's inline _changeHandler (bound on every radio) also
    // fires on this same change event and runs computeVariantFromSelectedOptions
    // which correctly reads the size <select> in addition to checked radios.
    if (window.variantSelector && typeof window.variantSelector.updateVariant === 'function') {
      setTimeout(() => { window.variantSelector.updateVariant(); }, 50);
    }
  }

  function updateVisualStatesForOption(optionName) {
    const optionRadios = document.querySelectorAll(`.product-header_radio input[name="${optionName}"]`);
    optionRadios.forEach(radio => {
      const label = radio.closest('label');
      if (!label) return;
      label.classList.toggle('selected', radio.checked);
    });
  }

  function updateAllVisualStates() {
    const optionNames = new Set();
    document.querySelectorAll('.product-header_radio input[type="radio"]').forEach(radio => {
      optionNames.add(radio.name);
    });
    optionNames.forEach(updateVisualStatesForOption);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantRadioHandler);
  } else {
    initVariantRadioHandler();
  }

  // Debug surface (visual state only — variant resolution lives elsewhere).
  window.variantRadioHandler = {
    init: initVariantRadioHandler,
    updateVisualStates: updateAllVisualStates
  };

})();
